const sharedMessageContainer = {
    flexDirection: 'row' as const,
    marginTop: 10,
    variants: {
        me: {true: {flexDirection: 'row-reverse' as const}},
        repeated: {true: {marginTop: 0}},
    },
}

export const messageContainer = {
    ...sharedMessageContainer,
    display: 'flex',
}

export const nativeMessageContainer = {...sharedMessageContainer}

const sharedSpeechBubbleContainer = {
    flex: 1,
    flexDirection: 'column' as const,
}

export const speechBubbleContainer = {
    ...sharedSpeechBubbleContainer,
    display: 'flex',
}

export const nativeSpeechBubbleContainer = {
    ...sharedSpeechBubbleContainer,
    flexShrink: 1,
}

const sharedSpeechBubble = {
    alignItems: 'center' as const,
    alignSelf: 'flex-start' as const,
    backgroundColor: '$messageSpeechBubbleDefault',
    borderColor: '$messageSpeechBubbleDefaultBorder',
    borderRadius: '$messageSpeechBubbleDefault',
    borderStyle: 'solid' as const,
    borderWidth: 1,
    flexDirection: 'row' as const,
    flexWrap: 'wrap' as const,
    justifyContent: 'flex-end' as const,
    marginTop: 4,
    paddingBottom: '$messageSpeechBubblePaddingVertical',
    paddingLeft: '$messageSpeechBubblePaddingHorizontal',
    paddingRight: '$messageSpeechBubblePaddingHorizontal',
    paddingTop: '$messageSpeechBubblePaddingVertical',
    variants: {me: {true: {alignSelf: 'flex-end' as const}}},
}

export const speechBubble = {
    ...sharedSpeechBubble,
    display: 'flex',
    lineHeight: 1.2,
}

export const nativeSpeechBubble = {...sharedSpeechBubble}

const sharedMessageText = {
    color: '$messageDeletedText',
    fontSize: '$messageText',
    fontStyle: 'italic' as const,
}

export const messageText = {
    ...sharedMessageText,
    display: 'flex',
}

export const nativeMessageText = {
    ...sharedMessageText,
    marginRight: 'auto',
}
